// Constants
import {
  TGSS_IFRAME_PRE_ORIGIN,
  TGSS_IFRAME_PRO_ORIGIN,
  WIDGET_HEIGHT_EVENT,
} from './constants/proof-income-method.handlers.utils.constants';
// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Types
import { ProofIncomeMethodsBuilderHandlersType } from '../types/proof-income-method.handlers.type';

const eventIsNotFromTgss = (origin: string): boolean =>
  ![TGSS_IFRAME_PRE_ORIGIN, TGSS_IFRAME_PRO_ORIGIN].includes(origin);

const isWidgetHeightEvent = (type: string): boolean => type === WIDGET_HEIGHT_EVENT;

const isTGSSSelectedMethod = (
  selectedMethod: ProofIncomeMethodsBuilderHandlersType['selectedMethod']
): boolean => selectedMethod === ProofIncomeMethodsEnumeration.TGSS;

export { eventIsNotFromTgss, isTGSSSelectedMethod, isWidgetHeightEvent };
